// Montania.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Importamos los 7 componentes
import HomePerfilEdit from "../../Jhimbo_home/homeEdit/HomePerfilEdit";
import HomePresentacionEdit from "../../Jhimbo_home/homeEdit/HomePresentacionEdit";
import HomeServicioEdit from "../../Jhimbo_home/homeEdit/HomeServicioEdit";
import HomeProductosEdit from "../../Jhimbo_home/homeEdit/HomeProductosEdit";
import HomeEleccionEdit from "../../Jhimbo_home/homeEdit/HomeEleccionEdit";
import HomeEquipoEdit from "../../Jhimbo_home/homeEdit/HomeEquipoEdit";
import HomeRedesEdit from "../../Jhimbo_home/homeEdit/HomeRedesEdit";

// Importaciones de imágenes (si las usas de fondo en Montania, si no, muévelas a cada componente)
import image_carrusel_page_3 from "../../../images/imagen_carrusel_page_3.png";
import marca1 from "../../../images/marca-chaqueno.jpeg";
import marca2 from "../../../images/marca-servimotor.jpeg";
import marca3 from "../../../images/marca-total.jpeg";
import marca4 from "../../../images/marca-todomaq.jpeg";
import imagen_producto from "../../../images/imagen_card_prueba.jpeg";
import "../../../css/jhimbo.css"; // tu CSS principal
import { ApiService } from "../../ApiService";
import { toast } from "react-toastify";

export const MontaniaEdit = ({ setOption, key_branch, loadImageS, convertPrice = (() => { }) }) => {
	const { authCode, sub_direc } = useParams();
	const [empresaDetails, setEmpresaDetails] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	useEffect(() => {
		if (setOption) {
			setOption(sub_direc);
		}
	}, [sub_direc, setOption]);
	useEffect(() => {
		const fetchCompanyInfo = async () => {
			const url = `api/company/information?key_branch=${key_branch}`;
			const response = await ApiService.fetchData(url);
			if (response) {
				setEmpresaDetails(response);
			}
		};
		fetchCompanyInfo();
	}, [key_branch]);
	// Estado para manejar el toggle de "Me gusta" (perfil)
	const [liked, setLiked] = useState(false);
	const handleLike = () => {
		setLiked((prev) => !prev);
	};

	// Estado para "seguir" (+ / check)
	const [isFollowed, setIsFollowed] = useState(false);
	const handleClickFollow = () => {
		setIsFollowed(!isFollowed);
	};

	// Carrusel principal (3 imágenes) en "Servicios"
	const images = [image_carrusel_page_3, marca4, image_carrusel_page_3];
	const [currentIndex, setCurrentIndex] = useState(0);

	const handlePrev = () => {
		setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
	};
	const handleNext = () => {
		setCurrentIndex((prev) => (prev + 1) % images.length);
	};
	const updateWhyChooseUs = async (updatedData) => {
		if (!key_branch) return;

		setIsLoading(true);

		try {
			// Create the payload with the current whyChooseUs data merged with the updates
			const currentWhyChooseUs = empresaDetails.why_choose_us || {};

			// Merge the updated section data with the existing section data
			const sectionKey = Object.keys(updatedData)[0]; // Get the section key (experience, coverage, etc.)
			const updatedSection = {
				...currentWhyChooseUs[sectionKey],
				...updatedData[sectionKey],
			};

			// Create the complete whyChooseUs object with the updated section
			const why_choose_us = {
				...currentWhyChooseUs,
				[sectionKey]: updatedSection,
			};

			// Make the API call
			const url = `api/company/update/main?key_branch=${key_branch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify({ why_choose_us }),
			};

			const response = await ApiService.fetchData(url, payload);

			if (response?.code === 200) {
				// Update local state
				setEmpresaDetails((prev) => ({
					...prev,
					why_choose_us,
				}));
				toast.success(response?.message);
			} else {
				console.error("Error updating whyChooseUs:", response?.message || "Unknown error");
			}
		} catch (error) {
			console.error("Error updating whyChooseUs:", error);
		} finally {
			setIsLoading(false);
		}
	};
	// Carrusel de Marcas en "Productos"
	const brands = [
		{ id: 1, name: "Neva", image: marca1 },
		{ id: 2, name: "UjiTools", image: marca2 },
		{ id: 3, name: "DongCheng", image: marca3 },
		{ id: 4, name: "Toyaki", image: marca4 },
		{ id: 5, name: "Dropeski", image: marca1 },
	];
	const [currentIndexBrands, setCurrentIndexBrands] = useState(0);
	const maxIndex = brands.length - 4; // Para no pasarte
	const handlePrevBrands = () => {
		if (currentIndexBrands > 0) {
			setCurrentIndexBrands((prev) => prev - 1);
		}
	};
	const handleNextBrands = () => {
		if (currentIndexBrands < maxIndex) {
			setCurrentIndexBrands((prev) => prev + 1);
		}
	};

	const refreshCompanyData = async () => {
		try {
			const url = `api/company/information?key_branch=${key_branch}`;
			const response = await ApiService.fetchData(url);
			if (response) {
				setEmpresaDetails(response);
			}
		} catch (error) {
			console.error("Error refreshing company data:", error);
		}
	};
	return (
		<div className="content-company">
			{/* 1) Sección perfil */}
			<HomePerfilEdit
				liked={liked}
				handleLike={handleLike}
				isFollowed={isFollowed}
				handleClickFollow={handleClickFollow}
				keyBranch={key_branch}
				loading={empresaDetails === null}
				data={empresaDetails}
			/>

			{/* 2) Sección presentación */}
			<HomePresentacionEdit empresaDetails={empresaDetails?.view1} keyBranch={key_branch} />

			{/* 3) Sección servicio (carrusel 3 imágenes) */}
			<HomeServicioEdit
				empresaDetails={empresaDetails?.view2}
				keyBranch={key_branch}
				currentIndex={currentIndex}
				handlePrev={handlePrev}
				handleNext={handleNext}
				onImageUpdateSuccess={refreshCompanyData}
			/>

			{/* 4) Sección productos (y carrusel de marcas) */}
			<HomeProductosEdit
				brands={brands}
				currentIndexBrands={currentIndexBrands}
				handlePrevBrands={handlePrevBrands}
				handleNextBrands={handleNextBrands}
				key_branch={key_branch}
				loadImageS={loadImageS}
				convertPrice={convertPrice}
			/>

			{/* 5) Sección elección */}
			<HomeEleccionEdit
				keyBranch={key_branch}
				empresaDetails={empresaDetails?.why_choose_us}
				updateWhyChooseUs={updateWhyChooseUs}
				isLoading={isLoading}
			/>

			{/* 6) Sección equipo */}
			<HomeEquipoEdit key_branch={key_branch} />

			{/* 7) Sección redes */}
			<HomeRedesEdit
				keyBranch={key_branch}
				socialMediaUrls={{
					wp_url: empresaDetails?.wp_url,
					tiktok_url: empresaDetails?.tiktok_url,
					fb_url: empresaDetails?.fb_url,
					ig_url: empresaDetails?.ig_url,
				}}
				loading={!empresaDetails}
			/>
		</div>
	);
};
